import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
  TableSortLabel as MuiTableSortLabel,
  Tooltip,
} from '@material-ui/core';
import TableCell from './TableCell';

const EXPAND_LAYOUT = 'expandLayout';

const DefaultExpandColumn = () => <TableCell type='head' width={5} sortDirection={false} />;

const TableHead = (props) => {
  const {
    data: {
      columnData,
      // numSelected,
      order,
      orderBy,
      // orderColumn,
      // rowCount,
      tableData,
      className,
      positionExpand,
      usingExpandLayout,
    },
    func: {
      onRequestSort,
      onSelectAllClick,
      // toolMenu
    },
    showingTableHeader,
  } = props;

  const createSortHandler = (columnId) => (event) => {
    onRequestSort(event, columnId);
  };

  return (
    <MuiTableHead className={className}>
      <MuiTableRow>
        {Object.keys(tableData.length !== 0 ? tableData[0] : []).length !== 4 &&
          Object.keys(tableData.length !== 0 ? tableData[0] : []).includes(EXPAND_LAYOUT) &&
          positionExpand === 'left' && <DefaultExpandColumn />}

        {(tableData.length > 0 || showingTableHeader) &&
          columnData.map((colData) => {
            const { columnId, numeric, width, label, noSort, hideSortIcon } = colData;
            return (
              <TableCell
                key={columnId}
                type='head'
                sortDirection={!noSort && orderBy === columnId ? order : false}
                onHeaderClick={onSelectAllClick}
                {...colData}>
                {!noSort ? (
                  <Tooltip
                    title={label || ''}
                    placement={numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}>
                    <MuiTableSortLabel
                      active={orderBy === columnId}
                      direction={order}
                      onClick={createSortHandler(columnId)}
                      hideSortIcon={hideSortIcon}>
                      <div style={{ width: width || 'auto' }}>{label}</div>
                    </MuiTableSortLabel>
                  </Tooltip>
                ) : (
                  <Box fontWeight={400} color='#8991a0'>
                    <div style={{ width: width || 'auto' }}>{label}</div>
                  </Box>
                )}
              </TableCell>
            );
          })}
        {usingExpandLayout && <DefaultExpandColumn />}
      </MuiTableRow>
    </MuiTableHead>
  );
};

TableHead.defaultProps = {
  columnData: [],
  orderColumn: '',
  numSelected: -1,
  order: '',
  orderBy: '',
  rowCount: -1,
  onRequestSort: () => {},
  onSelectAllClick: () => {},
  toolMenu: null,
  usingForFactoryAudit: false,
  titleTableHead: undefined,
  showingTableHeader: false,
};

TableHead.propTypes = {
  columnData: PropTypes.arrayOf(PropTypes.object),
  data: PropTypes.object.isRequired,
  func: PropTypes.object.isRequired,
  numSelected: PropTypes.number,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  orderColumn: PropTypes.string,
  rowCount: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  toolMenu: PropTypes.func,
  usingForFactoryAudit: PropTypes.bool,
  titleTableHead: PropTypes.string,
  showingTableHeader: PropTypes.bool,
};

export default TableHead;
